import { UiDetailsCard } from '@ui/molecules-details-card';

import { MaskedIban } from './MaskedIban/MaskedIban';
import { Wrapper } from './Wrapper/Wrapper';

export const UiBankCard = {
  BankName: UiDetailsCard.Content,
  Header: UiDetailsCard.Header,
  MaskedIban: MaskedIban,
  Wrapper: Wrapper,
};
